import { render, staticRenderFns } from "./DescargasWebService.vue?vue&type=template&id=63974c24&scoped=true&"
import script from "./DescargasWebService.vue?vue&type=script&lang=js&"
export * from "./DescargasWebService.vue?vue&type=script&lang=js&"
import style0 from "./DescargasWebService.vue?vue&type=style&index=0&id=63974c24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63974c24",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
